import { Day } from './types'

export const DAYS = [Day.SUNDAY, Day.MONDAY, Day.TUESDAY, Day.WEDNESDAY, Day.THURSDAY, Day.FRIDAY, Day.SATURDAY]

export const DEFAULT_FIRST_DAY_OF_WEEK = Day.SUNDAY
